import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";

import InlineLinkIconButton from "./inline-link-icon-button.jsx";
import * as util from "../../util";

class PassSalesAnalyticsTable extends React.Component {
  constructor(props) {
    super(props);
    this._makeRow = this._makeRow.bind(this);
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _makeRow(eventBucket, id, data, options = {}) {
    let noWrapTdStyle = { whiteSpace: "nowrap" };
    const isMembership = this.props.isMembership;
    const routeLocation = isMembership ? "memberships" : "pass_buckets";

    return (
      <Tr key={id}>
        <Td column="Pass bucket" value={options.pass_bucket.name}>
          <span>
            {options.pass_bucket.name}
            {options.pass_bucket.id && (
              <InlineLinkIconButton
                onTouchTap={() => {
                  this.context.router.push(
                    `/event_buckets/${eventBucket}/${routeLocation}/${options.pass_bucket.id}`
                  );
                }}
                tooltip={this.props.isMembership ? "View membership bucket" : "View pass bucket"}
              />
            )}
          </span>
        </Td>
        <Td column="Web" value={data.web} style={noWrapTdStyle}>
          {util.formatPrice(data.web)}
        </Td>
        <Td column="Box office" value={data.box_office} style={noWrapTdStyle}>
          {util.formatPrice(data.box_office)}
        </Td>
        <Td column="Renewals" value={data.autorenewal} style={noWrapTdStyle}>
          {util.formatPrice(data.autorenewal)}
        </Td>
        <Td column="Total" value={data.total} style={noWrapTdStyle}>
          {util.formatPrice(data.total)}
        </Td>
      </Tr>
    );
  }

  downloadCsv(data, passBuckets) {
    util.clientSideDownload(
      `${this.props.isMembership
        ? "membership-sales-analytics"
        : "pass-sales-analytics"
      }-${util.snakeCase(this.props.eventBucket.name)}.csv`,
      "text/csv",
      util.makeCsv(
        [["Pass bucket", "Web", "Box office", "Renewals", "Total"]].concat(
          Object.keys(data).map(id => {
            return [
              (passBuckets[id] || { name: "Deleted pass bucket" }).name,
              data[id].web / 100 || 0,
              data[id].box_office / 100 || 0,
              data[id].autorenewal / 100 || 0,
              data[id].total / 100 || 0
            ];
          })
        )
      )
    );
  }

  render() {
    let { data, eventBucket, passBuckets, isMembership, itemsPerPage } = this.props;

    const defaultItemsPerPage = 25
    const itemsPer = itemsPerPage ? itemsPerPage : defaultItemsPerPage;

    let rows = Object.keys(data).map(id => {
      return this._makeRow(eventBucket.id, id, data[id], {
        pass_bucket: passBuckets[id] || { name: "Deleted pass bucket" }
      });
    });

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={["Pass bucket", "Web", "Box office", "Renewals", "Total"]}
          itemsPerPage={itemsPer}
          defaultSort={{ column: "Total", direction: "desc" }}
          columns={[{ key: "Pass bucket", label: isMembership ? "Membership Bucket" : "Pass Bucket" }, "Web", "Box office", "Renewals", "Total"]}
        >
          {rows}
        </Table>
        <RaisedButton
          style={{ marginTop: "1em" }}
          label="Download (.csv)"
          onTouchTap={() => this.downloadCsv(data, passBuckets)}
        />
      </div>
    );
  }
}

export default PassSalesAnalyticsTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-sales-analytics-table.jsx